import { getConditionalObject } from 'utils/data';

export const tooltipIconStyles = {
  cursor: 'pointer',
};

export const sectionGridStyles = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, 1fr)' },
  gap: 2,
};

export const getFieldColumnStyles = isFullWidth => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  ...getConditionalObject(isFullWidth, { gridColumn: '1 / -1' }),
});

export const getFieldValueStyles = isFullWidth =>
  getConditionalObject(isFullWidth, { whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' });

export const fieldLabelRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};
